import { UsersFetchers } from '@members/data-fetch';
import { useDecoratedSWR } from '@members/data-fetch/useDecoratedSWR';

/**
 * Fetches free trial eligibility on demand.
 * Use this hook only in components that actually need to know
 * whether the current user is eligible for a free trial.
 *
 * This was previously fetched globally in useMembershipTieringInfo / TierProvider,
 * causing every page load in the members app to fire
 * GET /api/user/free_trial_eligibility — even for paid subscribers.
 */
export const useIsEligibleForFreeTrial = () => {
  const { data } = useDecoratedSWR(...UsersFetchers.CheckFreeTrialEligibility({}));
  return data?.isEligibleForFreeTrial;
};
